import ImageView from "./ImageView";

export default ImageView;
